export default __webpack_public_path__ + "static/media/Realcase-socialMedia.9df35e8f.jpg";